export default __webpack_public_path__ + "static/media/739.53e39399.png";